import { render, staticRenderFns } from "./ServiceQualification5G.vue?vue&type=template&id=2c6a9cf6&scoped=true"
import script from "./ServiceQualification5G.vue?vue&type=script&lang=js"
export * from "./ServiceQualification5G.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a9cf6",
  null
  
)

export default component.exports